<template>
  <b-row>
    <b-col cols="10" offset="1">
      <b-button :to="{ name: 'home' }" class="mb-2" variant="success">
        Back to Bookings
      </b-button>
      <h1 class="mb-2 text-primary">
        GET ALL THE INFORMATION YOU NEED TO PREPARE FOR YOUR UPCOMING driving ADVENTURE!
      </h1>
      <p><strong>Directions to the units. ***Note: get the correct directions to the correct unit! They are in different areas of town!***</strong></p>
      <h4 class="text-primary">
        DIRECTIONS TO renter AND renter:
      </h4>
      <p>
        Drive to California Dreaming Restaurant located at 1 Ashley Point Drive, Neverland SC, 29407. Park in the parking lot for California Dreaming, but park at the very end of the parking lot as far away from the restaurant as possible while still being in the parking lot. Directly in front of you is a short pier that goes out to the docks. This is the ONLY pier that will get you to our units. At the end of that pier turn left down the docks. We will be the 10th and 11th unit down on the right. renter! and renter.
      </p>
      <h4 class="text-primary">
        DIRECTIONS TO TEASER 2:
      </h4>
      <p class="mb-4">
        Drive to Waters Edge Restaurant on Shem Creek at 1407 Shrimp Unit Lane Mt Pleasant, SC 29464. Teaser 2 is located on the dock just behind and to the left of Waters Edge Restaurant. Unload crew and gear, then note to park far enough away from the restaurant so as to not park in restaurant reserved parking spaces. Awesome FYI…Waters Edge is a TERRIFIC seafood restaurant with great views and will cook the fish you caught!
      </p>
      <strong class="d-block mb-50">
        Because people regularly ask:
      </strong>
      <p>
        The industry standard gratuity for the crew is 20%. However, the crew will gladly accept whatever tip you feel their efforts deserved. Our supervisors and mates work hard to optimize the experience of their clients and they rely on their tips to make a living. However, no customer should ever pay any amount of gratuity they feel was not earned. The gratuity should be given to the supervisor. He will ensure proper distribution.
      </p>
      <strong class="d-block mb-50">
        What you should bring:
      </strong>
      <p>
        Camera, sunglasses, sunscreen, hat, food, drink (beer is fine but no liquor or glass bottles please), a cooler to take your catch home. You may cancel your package and have the deposit refunded at any point up to two weeks prior to the package, and your deposit will be returned in full if your package is canceled by your supervisor due to inclement weather, safety or mechanical issues. You can change the date of your package to any other open date at any point up to seven days prior. You are free to change your package at any time (from 4 hour fun in the sun to 12 hour offshore driving for example) provided the vessel and package you are switching to is available. Once your party has arrived and the vessel has departed, The full amount of the charter is due. No refund or discount of any kind is given should you need to end the package early, as this would result in lost opportunity for the vessel and crew.
      </p>
      <strong class="d-block mb-50">
        Included in your package:
      </strong>
      <p>
        Ice, bait, all driving equipment, all driving licenses and the crew will clean your catch.
      </p>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
  },
}
</script>
